import * as React from 'react';

const ExchangeArrow = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_4944_41906)">
      <circle cx="16" cy="16" r="9" fill="white" />
      <g clipPath="url(#clip0_4944_41906)">
        <path
          d="M10 18.1368C11.432 14.8636 14.7051 12.4091 19.4103 16.0914"
          stroke="black"
          strokeWidth="1.69181"
        />
        <path d="M22.1027 18.5784L16.8392 18.2384L21.7627 13.3149L22.1027 18.5784Z" fill="black" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_4944_41906"
        x="0.0769229"
        y="0.0769229"
        width="31.8462"
        height="31.8462"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3.46154" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.833333 0 0 0 0 0.833333 0 0 0 0 0.833333 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4944_41906" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4944_41906"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_4944_41906">
        <rect width="14" height="6" fill="white" transform="translate(9 13)" />
      </clipPath>
    </defs>
  </svg>
);

export default ExchangeArrow;
